import { FieldInterface } from '../../components/FieldTextInput/types';
import { FormDialogProps } from '../../components/FormDialog/types';
import AddButton from '../../components/Buttons/AddButton';
import EditButton from '../../components/Buttons/EditButton';
import SkillsManager from '../../components/SkillsManager/SkillsManager';
import StageFirstScreen from '../../components/StageFirstScreen/StageFirstScreen';
import ExerciseDialogContent from '../../components/ExerciseDialogContent/ExerciseDialogContent';

const missionsDialogFields = [
    {
        name: 'id',
        variant: 'outlined',
        required: false,
        type: 'text',
        hidden: true,
        id: 'id',
    },
    {
        name: 'name',
        variant: 'outlined',
        required: false,
        type: 'text',
        id: 'name',
        label: 'Course title',
        autoFocus: true,
    },
    {
        name: 'stagesTitle',
        variant: 'outlined',
        required: false,
        type: 'text',
        id: 'stagesTitle',
        label: 'Chapter title',
    },
    {
        name: 'exercisesTitle',
        variant: 'outlined',
        required: false,
        type: 'text',
        id: 'exercisesTitle',
        label: 'Lesson titles',
    },
] as FieldInterface[];

export const missionsDialogParams = {
    buttonLabel: 'Add',
    button: AddButton,
    leftBtnName: 'Save',
    rightBtnName: 'Publish',
    leftBtnType: 'submit',
    rightBtnType: 'button',
    publish: true,
    title: 'Add new course',
    textFields: missionsDialogFields.filter((field) => {
        return field.id !== 'id';
    }),
    component: { item: SkillsManager, filedName: '' },
} as FormDialogProps;

export const editMissionsDialogParams = {
    buttonLabel: 'Edit',
    button: EditButton,
    leftBtnName: 'Save',
    rightBtnName: 'Publish',
    leftBtnType: 'submit',
    rightBtnType: 'button',
    publish: true,
    title: 'Edit course',
    textFields: missionsDialogFields,
    component: { item: SkillsManager, filedName: '' },
} as FormDialogProps;

const stagesDialogFields = [
    {
        name: 'id',
        variant: 'outlined',
        required: false,
        type: 'text',
        hidden: true,
        id: 'id',
    },
    {
        name: 'name',
        variant: 'outlined',
        required: false,
        type: 'text',
        id: 'name',
        label: 'Chapter name',
        autoFocus: true,
    },
] as FieldInterface[];

export const stagesDialogParams = {
    buttonLabel: 'Add',
    button: AddButton,
    rightBtnName: 'Save',
    title: 'Add new chapter',
    textFields: stagesDialogFields.filter((field) => {
        return field.id !== 'id';
    }),
    component: { item: StageFirstScreen, filedName: '' },
} as FormDialogProps;

export const editStagesDialogParams = {
    buttonLabel: 'Edit',
    button: EditButton,
    rightBtnName: 'Save',
    title: 'Edit chapter',
    textFields: stagesDialogFields,
    component: { item: StageFirstScreen, filedName: '' },
} as FormDialogProps;

export const exercisesDialogParams = {
    buttonLabel: 'Add',
    button: AddButton,
    rightBtnName: 'Save',
    title: 'Add new lesson',
    component: { item: ExerciseDialogContent, filedName: '' },
} as FormDialogProps;

export const editExercisesDialogParams = {
    buttonLabel: 'Edit',
    button: EditButton,
    rightBtnName: 'Save',
    title: 'Edit lesson',
    component: { item: ExerciseDialogContent, filedName: '' },
} as FormDialogProps;
